import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Clock } from 'lucide-react';

/**
 * Lightweight modal that appears during the last `warningSeconds` of an idle
 * session and lets the user either stay signed in or log out.
 */
export function IdleWarningDialog({ open, remainingSeconds, onStay, onLogoutNow }) {
    const [label, setLabel] = useState('');
    useEffect(() => {
        if (!open) return;
        const s = Math.max(0, Math.floor(remainingSeconds || 0));
        const mm = Math.floor(s / 60);
        const ss = s % 60;
        setLabel(`${mm}:${ss.toString().padStart(2, '0')}`);
    }, [open, remainingSeconds]);

    return (
        <Dialog open={open} onOpenChange={() => { /* modal-only */ }}>
            <DialogContent className="max-w-md" data-testid="idle-warning-dialog">
                <DialogHeader>
                    <DialogTitle className="font-heading flex items-center gap-2">
                        <Clock className="h-5 w-5 text-amber-600" />
                        Bleiben Sie angemeldet?
                    </DialogTitle>
                </DialogHeader>
                <div className="space-y-2">
                    <p className="text-sm text-gray-600">
                        Aufgrund Inaktivität werden Sie in Kürze automatisch abgemeldet.
                        Möchten Sie weiterarbeiten?
                    </p>
                    <div className="flex items-center justify-center py-2">
                        <div className="text-3xl font-mono font-bold text-amber-600 tabular-nums" data-testid="idle-countdown">
                            {label}
                        </div>
                    </div>
                </div>
                <DialogFooter className="gap-2 sm:gap-2">
                    <Button variant="outline" onClick={onLogoutNow} data-testid="idle-logout-now">
                        Jetzt abmelden
                    </Button>
                    <Button onClick={onStay} data-testid="idle-stay">
                        Weiterarbeiten
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default IdleWarningDialog;
